import React, { Component } from 'react';

import Api from '../api/api';
import intl from 'react-intl-universal';
import Select from 'react-select';
import api from '../api/api';
import axios from 'axios';
import "./Login.css"
import Modal from 'react-modal';


export default class Download extends Component {
  constructor(props) {
    super();
    this.state = {
      downloadurl: '', //leadshub app 1.x
      overseadownloadurl:'', //leadshub app 2.x
      isWeixin: false

    };
    this.submitAndroid = this.submitAndroid.bind(this);
    this.submitAndroidOversea = this.submitAndroidOversea.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitIOS = this.submitIOS.bind(this);
  }

  componentDidMount() {
    this.getInformation();
    // this.getDownload();
    this.setState({ overseadownloadurl: 'https://static.tyrehubtech.com/app/app_leadshub.apk' });    
    this.setState({ downloadurl: 'https://bucket.taihapo.com.cn/app/rBNzcWFtMd-ATJyTAPD0oVhMhA09.7.apk' });

  }
  render() {
    const { selectedOption } = this.state;
    return (      
        <div style={{ textAlign: 'center' ,}} >
          <div style={{ textAlign: 'center' ,width: '100%',height:'220px',backgroundColor:'#3385ff',color:"#fff",}} >
            <img style={{ width:"228" ,height:"38", marginTop: '15%',borderRadius: '50%' }} src="https://mobilhubdiagnostics.com/img/logo-1667829529.jpg"  alt="" />
            {/* <img style={{ width: '25%', marginTop: '15%',borderRadius: '50%' }} src={require('../assets/icon-60@3x.png')} alt="" /> */}
            {/* <img style={{ width: '25%', marginTop: '15%' }} src={require('../assets/image/ic_launcher.png')} alt="" /> */}
            <p style={{ marginTop: 10 , fontWeight:'500'}}  >Leadshub App</p>
          </div>

          <div className="form">
            <p style={{ marginTop: 30 , fontWeight:'500'}}  >Leadshub App 2.X</p>
            <div className="buttonxiazai" onClick={this.submitAndroidOversea}>
              {/* <img src={require('../assets/image/google.jpg')} style={{ width: 20, height: 25, marginLeft: 15 }}></img> */}
              <img src={require('../assets/image/android.png')} style={{ width: 20, height: 25, marginLeft: 15 }}></img>
              <div style={{ height: '100%', background: '#fff', width: 1, marginLeft: 15, marginRight: 15 }}></div>
              <div style={{ flexGrow: 1, textAlign: 'center' }}>{"Android"}</div>
            </div>
              {/* <div><a href={this.state.overseadownloadurl}>Download from www.tyrehubtech.com</a></div> */}
            <div className="buttonxiazaiios" onClick={this.submitIOSOversea}>
              <img src={require('../assets/image/ios.png')} style={{ width: 20, height: 25, marginLeft: 15 }}></img>
              <div style={{ height: '100%', background: '#fff', width: 1, marginLeft: 15, marginRight: 15 }}></div>
              <div style={{ flexGrow: 1, textAlign: 'center' }}> {'IOS'}</div>
            </div>
          </div>
          <div className="form">
          <p style={{ marginTop: 30 ,fontWeight:'500'}}>Leadshub App 1.X</p>
            <div className="buttonxiazai" onClick={this.submitAndroid}>
              <img src={require('../assets/image/android.png')} style={{ width: 20, height: 25, marginLeft: 15 }}></img>
              <div style={{ height: '100%', background: '#fff', width: 1, marginLeft: 15, marginRight: 15 }}></div>
              <div style={{ flexGrow: 1, textAlign: 'center' }}>{"Android"}</div></div>

            <div className="buttonxiazaiios" onClick={this.submitIOS}>
              <img src={require('../assets/image/ios.png')} style={{ width: 20, height: 25, marginLeft: 15 }}></img>
              <div style={{ height: '100%', background: '#fff', width: 1, marginLeft: 15, marginRight: 15 }}></div>
              <div style={{ flexGrow: 1, textAlign: 'center' }}> {'IOS'}</div></div>
          </div>
        
        {this.state.isWeixin && (<div className='Modal' onClick={this.closeModal}>
          <img className={this.IsPC() ? 'pcOverlayImg' : 'OverlayImg'} src={require('../assets/fxbj.png')} alt="" />
        </div>)}
      </div>
    )
  }

  closeModal() {
    this.setState({ isWeixin: false })
  }

  handleChange = selectedOption => {
    intl.options.currentLocale = selectedOption.value;
    this.forceUpdate()
    this.setState(
      { selectedOption: selectedOption },
      () => {
        console.log(`Option selected:`, this.state.selectedOption)
      }
    );
  };

  getDownload() {
    api.getDownload().then(res => {
      if (res.data.code == 0) {
        this.setState({ downloadurl: res.data.data.url })
      }
    })
  }

  submitAndroidOversea(){
    // window.location.href = "https://play.google.com/store/apps/details?id=com.tyrehub.leadshub";
    window.location.href = this.state.overseadownloadurl;
  }

  submitAndroid() {
    /*	
    if(this.state.qs === '' || this.state.staff_number === ''){
      this.setState({errorInfo:'信息填写不完整'})
      return
    }
     axios.get(this.state.downloadurl,{    
    // 传参
   },
   {    responseType:'blob'   
    // 设置响应数据类型
   }).then(res=>{    
     if (res.status == 200) 
     {        
       let url = window.URL.createObjectURL(new Blob([res.data]))        
       let link= document.createElement('a')       
        link.style.display='none'        
        link.href=url       
         link.setAttribute('download', "tyrehub.apk")    // 自定义下载文件名（如exemple.txt）       
          document.body.appendChild(link)       
           link.click()    }})c
    */

    window.location.href = this.state.downloadurl;

  }

  submitIOSOversea() {

    window.location.href = "https://apps.apple.com/lc/app/tire-scanner-leadshub/id1594312218";
    // window.location.href = "https://itunes.apple.com/cn/app/id1594312218";
  }

  submitIOS() {

    window.location.href = "https://itunes.apple.com/cn/app/id1493366906";
  }

  getInformation() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      console.log('微信')

      this.setState({ isWeixin: true })
    } else {

      this.setState({ isWeixin: false })

      console.log('其他')
    }
  }



  IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;

  }


}



// WEBPACK FOOTER //
// ./src/views/Dowload.jsx